import ApiService from "@/services/base";
import { FILTER_VALUES } from "@/constants/filters";
import { config } from "@/utils/config";
let AuditLogsService = class AuditLogsService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    /**
   * Get audit logs for a date range
   */ async getAuditLogs(startDate, endDate, apiKeyId, customerId, limit, nextToken) {
        const params = new URLSearchParams({
            startDate
        });
        if (endDate) {
            params.append("endDate", endDate);
        }
        if (apiKeyId && apiKeyId !== FILTER_VALUES.ALL) {
            params.append("apiKeyId", apiKeyId);
        }
        if (customerId) {
            params.append("customerId", customerId);
        }
        if (limit) {
            params.append("limit", limit.toString());
        }
        if (nextToken) {
            params.append("nextToken", nextToken);
        }
        const response = await this.get({
            url: `/direct/audit-logs?${params.toString()}`
        });
        return response.data;
    }
};
export default AuditLogsService;
